export { default as RdsHeading } from './Heading';
export * from './Heading.interface';
